// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tabParset[data-v-bb58f49c] {\n  width: 90%;\n}", ""]);
// Exports
module.exports = exports;
